import { render, staticRenderFns } from "./batchPro.vue?vue&type=template&id=33024f32&scoped=true&"
import script from "./batchPro.vue?vue&type=script&lang=js&"
export * from "./batchPro.vue?vue&type=script&lang=js&"
import style0 from "./batchPro.vue?vue&type=style&index=0&id=33024f32&lang=less&scoped=true&"
import style1 from "./batchPro.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33024f32",
  null
  
)

export default component.exports